import { render, staticRenderFns } from "./doctor.vue?vue&type=template&id=0446911c&scoped=true"
import script from "./doctor.vue?vue&type=script&lang=ts"
export * from "./doctor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0446911c",
  null
  
)

export default component.exports